module.exports = __webpack_public_path__ + "static/img/Miximo-1.5fc123f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/Miximo-1.png
// module id = 1774
// module chunks = 0